import React, { useEffect, useRef } from 'react';
import { ApiAuth } from '../../api/auth';
import { StyledEmailConfirmation } from './styled';
import Logo from '../../components/Logo';
import { makeStyles } from '../../utils/styles';
import { useApi } from '../../hooks/useApi';
import { paths } from '../../routes';
import Paper from '../../components/Paper';
import Button from '../../components/Button';
import Typography from '../../components/Typography';
import Loader from '../../components/Loader';
import useTheme from '../../hooks/useTheme';
import useQuery from '../../hooks/useQuery';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((css) => ({
    logo: css`
        margin-bottom: 50px;
    `,
    paper: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        overflow: hidden;
        max-width: 380px;
        padding: 40px 40px 30px 40px;
        width: 100%;
        min-height: 200px;
    `,
    btn: css`
        padding: 10px 45px;
    `,
    typography: css`
        line-height: 1.8em;
        margin-bottom: 30px;
    `,
}));

const EmailConfirmation = () => {
    const styles = useStyles();
    const theme = useTheme();
    const history = useHistory();
    const query = useQuery();

    const confirmationRef = useRef(null);
    const { t } = useTranslation()
    //Setup request
    const [{ data, loading, error }, emailConfirmation] = useApi(ApiAuth.emailConfirmation, { manual: true });

    //Update confirmation value from query parameters
    useEffect(() => {
        const confirmation = query.get("confirmation");
        if (confirmation) {
            confirmationRef.current = confirmation;
        }
    }, [query]);

    //Confirm email address
    useEffect(() => {
        if (confirmationRef.current) {
            emailConfirmation(confirmationRef.current);
        } else {
            history.push(paths.login);
        }
    }, [emailConfirmation, history]);

    return (
        <StyledEmailConfirmation>
            <Logo
                variant="white"
                customStyle={styles.logo}
            />
            <Paper customStyle={styles.paper}>
                {
                    !loading &&
                    <>
                        <Typography customStyle={styles.typography} color={theme.colors.purple} align="center" as="h2">
                            {data?.ok && error === null ? t('Konto zostało aktywowane') : t('Ups, coś poszło nie tak')}
                        </Typography>
                        <Button to={paths.login} customStyle={styles.btn}>
                            {data?.ok && error === null ? t('Zaloguj się') : t('Wróć')}
                        </Button>
                    </>
                }
                <Loader show={loading} />
            </Paper>
        </StyledEmailConfirmation>
    )
}

export default EmailConfirmation;
